<template>
  <div class="dispute-issuer-comment">
    <div class="title">
      Issuer Comment for {{ issuerComment.type }}
    </div>
    <div class="fields">
      <div class="column">
        <FieldValue
          v-for="(value, key) in issuerComment.comment"
          :key="key"
          :field-value="value"
          :field-name="formatFieldName(key)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import FieldValue from "@/components/common/FieldValue.vue";
export default {
  name: "DisputeIssuerComment",
  components: {FieldValue},
  props: {
    issuerComment: {
      type: Object,
      required: true
    },
  },
  methods: {
    formatFieldName(key) {
      // Convert camelCase to Title Case with spaces
      // e.g., "cancellationMethod" -> "Cancellation Method"
      return key
        .replace(/([A-Z])/g, ' $1') // Add space before capital letters
        .replace(/^./, str => str.toUpperCase()) // Capitalize first letter
        .trim();
    }
  }
}
</script>

<style lang="scss">
.dispute-issuer-comment {
  & .title {
    text-align: left;
    font-size: 16px;
    font-weight: $weight-bold;
  }

  & .fields {
    display: flex;

    & .column {
      text-align: left;
      flex: 1;
    }
  }

  // Override FieldValue styles to allow content wrapping
  .field-value-container {
    .field-value {
      height: auto;
      min-height: 20px;
      word-wrap: break-word;
      word-break: break-word;
      white-space: normal;
      overflow-wrap: break-word;
    }
  }
}
</style>